'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdLightbulbOutline = function MdLightbulbOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm24.8 21.8c2.2-1.6 3.6-4.1 3.6-6.8 0-4.6-3.8-8.4-8.4-8.4s-8.4 3.8-8.4 8.4c0 2.7 1.4 5.2 3.6 6.8l1.4 1v3.8h6.8v-3.8z m-4.8-18.4c6.4 0 11.6 5.2 11.6 11.6 0 4-1.9 7.4-5 9.5v3.9c0 0.9-0.7 1.6-1.6 1.6h-10c-0.9 0-1.6-0.7-1.6-1.6v-3.9c-3.1-2.1-5-5.5-5-9.5 0-6.4 5.2-11.6 11.6-11.6z m-5 31.6v-1.6h10v1.6c0 0.9-0.7 1.6-1.6 1.6h-6.8c-0.9 0-1.6-0.7-1.6-1.6z' })
        )
    );
};

exports.default = MdLightbulbOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/lightbulb-outline.js
// module id = 890
// module chunks = 0